import { render, staticRenderFns } from "./ChristmasChoir.vue?vue&type=template&id=a9adc6be&scoped=true&"
import script from "./ChristmasChoir.vue?vue&type=script&lang=js&"
export * from "./ChristmasChoir.vue?vue&type=script&lang=js&"
import style0 from "./ChristmasChoir.vue?vue&type=style&index=0&id=a9adc6be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9adc6be",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
